import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const forceCloseQuestion = async (questionId) => {
  const data = await request.get(
    `/Question/close`,
    { questionId },
    'При отправке запроса на закрытие вопроса произошла ошибка',
    'Error'
  );

  return data;
};

const useForceCloseQuestionMutation = (options) => {
  return useMutation(
    ({ questionId }) => forceCloseQuestion(questionId),
    options
  );
};

export default useForceCloseQuestionMutation;
